/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from './core/BaseHttpRequest';
import type { OpenAPIConfig } from './core/OpenAPI';
import { FetchHttpRequest } from './core/FetchHttpRequest';

import { AddressControllerService } from './services/AddressControllerService';
import { AiControllerService } from './services/AiControllerService';
import { AiOldControllerService } from './services/AiOldControllerService';
import { AnalyticsControllerService } from './services/AnalyticsControllerService';
import { AptosAddressControllerService } from './services/AptosAddressControllerService';
import { AptosAnalyticsControllerService } from './services/AptosAnalyticsControllerService';
import { AptosBlockControllerService } from './services/AptosBlockControllerService';
import { AptosCoinControllerService } from './services/AptosCoinControllerService';
import { AptosDailyScheduleControllerService } from './services/AptosDailyScheduleControllerService';
import { AptosDefiControllerService } from './services/AptosDefiControllerService';
import { AptosExternalControllerService } from './services/AptosExternalControllerService';
import { AptosGeneralControllerService } from './services/AptosGeneralControllerService';
import { AptosHourScheduleControllerService } from './services/AptosHourScheduleControllerService';
import { AptosNetflowControllerService } from './services/AptosNetflowControllerService';
import { AptosNftControllerService } from './services/AptosNftControllerService';
import { AptosNftSchedulerControllerService } from './services/AptosNftSchedulerControllerService';
import { AptosNodeControllerService } from './services/AptosNodeControllerService';
import { AptosSearchControllerService } from './services/AptosSearchControllerService';
import { AptosSecondlyScheduleControllerService } from './services/AptosSecondlyScheduleControllerService';
import { AptosTrxControllerService } from './services/AptosTrxControllerService';
import { BabylonAddressControllerService } from './services/BabylonAddressControllerService';
import { BabylonBlockControllerService } from './services/BabylonBlockControllerService';
import { BabylonDailyScheduleControllerService } from './services/BabylonDailyScheduleControllerService';
import { BabylonFinalityProviderControllerService } from './services/BabylonFinalityProviderControllerService';
import { BabylonGeneralControllerService } from './services/BabylonGeneralControllerService';
import { BabylonMinutelyScheduleControllerService } from './services/BabylonMinutelyScheduleControllerService';
import { BabylonSearchControllerService } from './services/BabylonSearchControllerService';
import { BabylonSecondlyScheduleControllerService } from './services/BabylonSecondlyScheduleControllerService';
import { BabylonStakingControllerService } from './services/BabylonStakingControllerService';
import { BabylonTrxControllerService } from './services/BabylonTrxControllerService';
import { BatchControllerService } from './services/BatchControllerService';
import { BlockControllerService } from './services/BlockControllerService';
import { CloudflareControllerService } from './services/CloudflareControllerService';
import { CoinControllerService } from './services/CoinControllerService';
import { CommonControllerService } from './services/CommonControllerService';
import { ContractControllerService } from './services/ContractControllerService';
import { CovenantCommitteeControllerService } from './services/CovenantCommitteeControllerService';
import { DailyScheduleControllerService } from './services/DailyScheduleControllerService';
import { DefiControllerService } from './services/DefiControllerService';
import { EpochControllerService } from './services/EpochControllerService';
import { EvmAddressControllerService } from './services/EvmAddressControllerService';
import { EvmAnalyticsControllerService } from './services/EvmAnalyticsControllerService';
import { EvmBlockControllerService } from './services/EvmBlockControllerService';
import { EvmDailyScheduleControllerService } from './services/EvmDailyScheduleControllerService';
import { EvmErc1155ControllerService } from './services/EvmErc1155ControllerService';
import { EvmErc20ControllerService } from './services/EvmErc20ControllerService';
import { EvmErc721ControllerService } from './services/EvmErc721ControllerService';
import { EvmGeneralControllerService } from './services/EvmGeneralControllerService';
import { EvmHourScheduleControllerService } from './services/EvmHourScheduleControllerService';
import { EvmMinutelyScheduleControllerService } from './services/EvmMinutelyScheduleControllerService';
import { EvmNftControllerService } from './services/EvmNftControllerService';
import { EvmSearchControllerService } from './services/EvmSearchControllerService';
import { EvmSecondlyScheduleControllerService } from './services/EvmSecondlyScheduleControllerService';
import { EvmStatusWorkerService } from './services/EvmStatusWorkerService';
import { EvmTokenControllerService } from './services/EvmTokenControllerService';
import { EvmTrxControllerService } from './services/EvmTrxControllerService';
import { ExternalNexonLwControllerService } from './services/ExternalNexonLwControllerService';
import { FaucetControllerService } from './services/FaucetControllerService';
import { FeatureControllerService } from './services/FeatureControllerService';
import { FeedbackControllerService } from './services/FeedbackControllerService';
import { FinalityProviderControllerService } from './services/FinalityProviderControllerService';
import { GasControllerService } from './services/GasControllerService';
import { GeneralControllerService } from './services/GeneralControllerService';
import { HumanityService } from './services/HumanityService';
import { KiteService } from './services/KiteService';
import { LwControllerService } from './services/LwControllerService';
import { MonitorControllerService } from './services/MonitorControllerService';
import { NetflowControllerService } from './services/NetflowControllerService';
import { NexonService } from './services/NexonService';
import { NftControllerService } from './services/NftControllerService';
import { NodeControllerService } from './services/NodeControllerService';
import { ProposalControllerService } from './services/ProposalControllerService';
import { RelayerControllerService } from './services/RelayerControllerService';
import { SearchControllerService } from './services/SearchControllerService';
import { SecretControllerService } from './services/SecretControllerService';
import { SomniaService } from './services/SomniaService';
import { StakingControllerService } from './services/StakingControllerService';
import { StorageControllerService } from './services/StorageControllerService';
import { TokenControllerService } from './services/TokenControllerService';
import { TrxControllerService } from './services/TrxControllerService';
import { ValidatorControllerService } from './services/ValidatorControllerService';

type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest;

export class Explorer {

    public readonly addressController: AddressControllerService;
    public readonly aiController: AiControllerService;
    public readonly aiOldController: AiOldControllerService;
    public readonly analyticsController: AnalyticsControllerService;
    public readonly aptosAddressController: AptosAddressControllerService;
    public readonly aptosAnalyticsController: AptosAnalyticsControllerService;
    public readonly aptosBlockController: AptosBlockControllerService;
    public readonly aptosCoinController: AptosCoinControllerService;
    public readonly aptosDailyScheduleController: AptosDailyScheduleControllerService;
    public readonly aptosDefiController: AptosDefiControllerService;
    public readonly aptosExternalController: AptosExternalControllerService;
    public readonly aptosGeneralController: AptosGeneralControllerService;
    public readonly aptosHourScheduleController: AptosHourScheduleControllerService;
    public readonly aptosNetflowController: AptosNetflowControllerService;
    public readonly aptosNftController: AptosNftControllerService;
    public readonly aptosNftSchedulerController: AptosNftSchedulerControllerService;
    public readonly aptosNodeController: AptosNodeControllerService;
    public readonly aptosSearchController: AptosSearchControllerService;
    public readonly aptosSecondlyScheduleController: AptosSecondlyScheduleControllerService;
    public readonly aptosTrxController: AptosTrxControllerService;
    public readonly babylonAddressController: BabylonAddressControllerService;
    public readonly babylonBlockController: BabylonBlockControllerService;
    public readonly babylonDailyScheduleController: BabylonDailyScheduleControllerService;
    public readonly babylonFinalityProviderController: BabylonFinalityProviderControllerService;
    public readonly babylonGeneralController: BabylonGeneralControllerService;
    public readonly babylonMinutelyScheduleController: BabylonMinutelyScheduleControllerService;
    public readonly babylonSearchController: BabylonSearchControllerService;
    public readonly babylonSecondlyScheduleController: BabylonSecondlyScheduleControllerService;
    public readonly babylonStakingController: BabylonStakingControllerService;
    public readonly babylonTrxController: BabylonTrxControllerService;
    public readonly batchController: BatchControllerService;
    public readonly blockController: BlockControllerService;
    public readonly cloudflareController: CloudflareControllerService;
    public readonly coinController: CoinControllerService;
    public readonly commonController: CommonControllerService;
    public readonly contractController: ContractControllerService;
    public readonly covenantCommitteeController: CovenantCommitteeControllerService;
    public readonly dailyScheduleController: DailyScheduleControllerService;
    public readonly defiController: DefiControllerService;
    public readonly epochController: EpochControllerService;
    public readonly evmAddressController: EvmAddressControllerService;
    public readonly evmAnalyticsController: EvmAnalyticsControllerService;
    public readonly evmBlockController: EvmBlockControllerService;
    public readonly evmDailyScheduleController: EvmDailyScheduleControllerService;
    public readonly evmErc1155Controller: EvmErc1155ControllerService;
    public readonly evmErc20Controller: EvmErc20ControllerService;
    public readonly evmErc721Controller: EvmErc721ControllerService;
    public readonly evmGeneralController: EvmGeneralControllerService;
    public readonly evmHourScheduleController: EvmHourScheduleControllerService;
    public readonly evmMinutelyScheduleController: EvmMinutelyScheduleControllerService;
    public readonly evmNftController: EvmNftControllerService;
    public readonly evmSearchController: EvmSearchControllerService;
    public readonly evmSecondlyScheduleController: EvmSecondlyScheduleControllerService;
    public readonly evmStatusWorker: EvmStatusWorkerService;
    public readonly evmTokenController: EvmTokenControllerService;
    public readonly evmTrxController: EvmTrxControllerService;
    public readonly externalNexonLwController: ExternalNexonLwControllerService;
    public readonly faucetController: FaucetControllerService;
    public readonly featureController: FeatureControllerService;
    public readonly feedbackController: FeedbackControllerService;
    public readonly finalityProviderController: FinalityProviderControllerService;
    public readonly gasController: GasControllerService;
    public readonly generalController: GeneralControllerService;
    public readonly humanity: HumanityService;
    public readonly kite: KiteService;
    public readonly lwController: LwControllerService;
    public readonly monitorController: MonitorControllerService;
    public readonly netflowController: NetflowControllerService;
    public readonly nexon: NexonService;
    public readonly nftController: NftControllerService;
    public readonly nodeController: NodeControllerService;
    public readonly proposalController: ProposalControllerService;
    public readonly relayerController: RelayerControllerService;
    public readonly searchController: SearchControllerService;
    public readonly secretController: SecretControllerService;
    public readonly somnia: SomniaService;
    public readonly stakingController: StakingControllerService;
    public readonly storageController: StorageControllerService;
    public readonly tokenController: TokenControllerService;
    public readonly trxController: TrxControllerService;
    public readonly validatorController: ValidatorControllerService;

    public readonly request: BaseHttpRequest;

    constructor(config?: Partial<OpenAPIConfig>, HttpRequest: HttpRequestConstructor = FetchHttpRequest) {
        this.request = new HttpRequest({
            BASE: config?.BASE ?? '',
            VERSION: config?.VERSION ?? '0',
            WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
            CREDENTIALS: config?.CREDENTIALS ?? 'include',
            TOKEN: config?.TOKEN,
            USERNAME: config?.USERNAME,
            PASSWORD: config?.PASSWORD,
            HEADERS: config?.HEADERS,
            ENCODE_PATH: config?.ENCODE_PATH,
        });

        this.addressController = new AddressControllerService(this.request);
        this.aiController = new AiControllerService(this.request);
        this.aiOldController = new AiOldControllerService(this.request);
        this.analyticsController = new AnalyticsControllerService(this.request);
        this.aptosAddressController = new AptosAddressControllerService(this.request);
        this.aptosAnalyticsController = new AptosAnalyticsControllerService(this.request);
        this.aptosBlockController = new AptosBlockControllerService(this.request);
        this.aptosCoinController = new AptosCoinControllerService(this.request);
        this.aptosDailyScheduleController = new AptosDailyScheduleControllerService(this.request);
        this.aptosDefiController = new AptosDefiControllerService(this.request);
        this.aptosExternalController = new AptosExternalControllerService(this.request);
        this.aptosGeneralController = new AptosGeneralControllerService(this.request);
        this.aptosHourScheduleController = new AptosHourScheduleControllerService(this.request);
        this.aptosNetflowController = new AptosNetflowControllerService(this.request);
        this.aptosNftController = new AptosNftControllerService(this.request);
        this.aptosNftSchedulerController = new AptosNftSchedulerControllerService(this.request);
        this.aptosNodeController = new AptosNodeControllerService(this.request);
        this.aptosSearchController = new AptosSearchControllerService(this.request);
        this.aptosSecondlyScheduleController = new AptosSecondlyScheduleControllerService(this.request);
        this.aptosTrxController = new AptosTrxControllerService(this.request);
        this.babylonAddressController = new BabylonAddressControllerService(this.request);
        this.babylonBlockController = new BabylonBlockControllerService(this.request);
        this.babylonDailyScheduleController = new BabylonDailyScheduleControllerService(this.request);
        this.babylonFinalityProviderController = new BabylonFinalityProviderControllerService(this.request);
        this.babylonGeneralController = new BabylonGeneralControllerService(this.request);
        this.babylonMinutelyScheduleController = new BabylonMinutelyScheduleControllerService(this.request);
        this.babylonSearchController = new BabylonSearchControllerService(this.request);
        this.babylonSecondlyScheduleController = new BabylonSecondlyScheduleControllerService(this.request);
        this.babylonStakingController = new BabylonStakingControllerService(this.request);
        this.babylonTrxController = new BabylonTrxControllerService(this.request);
        this.batchController = new BatchControllerService(this.request);
        this.blockController = new BlockControllerService(this.request);
        this.cloudflareController = new CloudflareControllerService(this.request);
        this.coinController = new CoinControllerService(this.request);
        this.commonController = new CommonControllerService(this.request);
        this.contractController = new ContractControllerService(this.request);
        this.covenantCommitteeController = new CovenantCommitteeControllerService(this.request);
        this.dailyScheduleController = new DailyScheduleControllerService(this.request);
        this.defiController = new DefiControllerService(this.request);
        this.epochController = new EpochControllerService(this.request);
        this.evmAddressController = new EvmAddressControllerService(this.request);
        this.evmAnalyticsController = new EvmAnalyticsControllerService(this.request);
        this.evmBlockController = new EvmBlockControllerService(this.request);
        this.evmDailyScheduleController = new EvmDailyScheduleControllerService(this.request);
        this.evmErc1155Controller = new EvmErc1155ControllerService(this.request);
        this.evmErc20Controller = new EvmErc20ControllerService(this.request);
        this.evmErc721Controller = new EvmErc721ControllerService(this.request);
        this.evmGeneralController = new EvmGeneralControllerService(this.request);
        this.evmHourScheduleController = new EvmHourScheduleControllerService(this.request);
        this.evmMinutelyScheduleController = new EvmMinutelyScheduleControllerService(this.request);
        this.evmNftController = new EvmNftControllerService(this.request);
        this.evmSearchController = new EvmSearchControllerService(this.request);
        this.evmSecondlyScheduleController = new EvmSecondlyScheduleControllerService(this.request);
        this.evmStatusWorker = new EvmStatusWorkerService(this.request);
        this.evmTokenController = new EvmTokenControllerService(this.request);
        this.evmTrxController = new EvmTrxControllerService(this.request);
        this.externalNexonLwController = new ExternalNexonLwControllerService(this.request);
        this.faucetController = new FaucetControllerService(this.request);
        this.featureController = new FeatureControllerService(this.request);
        this.feedbackController = new FeedbackControllerService(this.request);
        this.finalityProviderController = new FinalityProviderControllerService(this.request);
        this.gasController = new GasControllerService(this.request);
        this.generalController = new GeneralControllerService(this.request);
        this.humanity = new HumanityService(this.request);
        this.kite = new KiteService(this.request);
        this.lwController = new LwControllerService(this.request);
        this.monitorController = new MonitorControllerService(this.request);
        this.netflowController = new NetflowControllerService(this.request);
        this.nexon = new NexonService(this.request);
        this.nftController = new NftControllerService(this.request);
        this.nodeController = new NodeControllerService(this.request);
        this.proposalController = new ProposalControllerService(this.request);
        this.relayerController = new RelayerControllerService(this.request);
        this.searchController = new SearchControllerService(this.request);
        this.secretController = new SecretControllerService(this.request);
        this.somnia = new SomniaService(this.request);
        this.stakingController = new StakingControllerService(this.request);
        this.storageController = new StorageControllerService(this.request);
        this.tokenController = new TokenControllerService(this.request);
        this.trxController = new TrxControllerService(this.request);
        this.validatorController = new ValidatorControllerService(this.request);
    }
}

